import { alpha } from "@mui/material/styles";

// Overrides de componentes MUI compartidos por ambos modos.
// Reciben la paleta ya resuelta (light u dark) para calcular tintes/alphas.
export const buildComponents = (palette) => ({
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        backgroundColor: palette.background.default,
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: alpha(palette.background.paper, 0.85),
        backdropFilter: "blur(8px)",
        color: palette.text.primary,
        boxShadow: "none",
        borderBottom: `1px solid ${palette.divider}`,
      },
    },
  },
  MuiToolbar: {
    styleOverrides: {
      root: {
        width: "100%",
        maxWidth: 980,
        marginLeft: "auto",
        marginRight: "auto",
        boxSizing: "border-box",
      },
    },
  },
  MuiContainer: {
    styleOverrides: {
      root: {
        maxWidth: "980px !important",
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        textTransform: "none",
        fontWeight: 600,
      },
      containedPrimary: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: `0 0 16px ${alpha(palette.primary.main, 0.35)}`,
        },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        border: `1px solid ${palette.divider}`,
        backgroundImage: "none",
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 8,
      },
      colorPrimary: {
        backgroundColor: alpha(palette.primary.main, 0.12),
        color: palette.primary.main,
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        "& fieldset": {
          borderColor: palette.divider,
        },
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: 16,
        backgroundImage: "none",
      },
    },
  },
  MuiAvatar: {
    styleOverrides: {
      root: {
        border: `2px solid ${palette.background.paper}`,
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: 8,
      },
    },
  },
});
